/**
 * @generated SignedSource<<b91fcf213c7e33002c41ad9c7268cac3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
export type DeliveryOrderHistoryTypeEnum = "delivery_order_canceled" | "delivery_order_completed" | "delivery_order_create" | "delivery_order_update" | "delivery_waybill_create" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder$data = {
  readonly histories: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly type: DeliveryOrderHistoryTypeEnum;
        readonly " $fragmentSpreads": FragmentRefs<"DeliveryOrderHistoryDialog_deliveryOrderHistory" | "DeliveryOrderHistoryTimelineItem_deliveryOrderHistory">;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
    readonly totalCount: number | null;
  };
  readonly id: string;
  readonly " $fragmentType": "DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder";
};
export type DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder$key = {
  readonly " $data"?: DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "histories"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./DeliveryOrderDeliveryOrderHistoryPaginatorRefreshQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder",
  "selections": [
    {
      "alias": "histories",
      "args": null,
      "concreteType": "DeliveryOrderHistoryConnection",
      "kind": "LinkedField",
      "name": "__DeliveryOrderDeliveryOrderHistoryPaginator_deliveryOrder_histories_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DeliveryOrderHistoryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "DeliveryOrderHistory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DeliveryOrderHistoryDialog_deliveryOrderHistory"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "DeliveryOrderHistoryTimelineItem_deliveryOrderHistory"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "DeliveryOrder",
  "abstractKey": null
};
})();

(node as any).hash = "1400a0072d8c6c4ff2c085ca503dfa25";

export default node;
